import { FaCheck, FaFloppyDisk, FaIndustry } from "react-icons/fa6";
import { Box, Button, Grid } from '@mui/material';

const FixedActionsContainer = ({ fixedActions, children }) => {
    if (fixedActions) {
        return (
            <Box
                position="fixed"
                bottom={8}
                left={16}
                right={16}
                zIndex={1200}
                display="flex"
                flexWrap="wrap"
                justifyContent="flex-end"
                gap={1.5}
                sx={{ pointerEvents: "none", "& > *": { pointerEvents: "auto" } }}
            >
                {children}
            </Box>
        );
    }

    return children;
};

const FormPageNavigation = ({
    noAction,
    production,
    updateProduction,
    details,
    verification,
    isSubmitting,
    submitButtonText,
    cancelButtonText,
    onCancel,
    fixedActions
}) => {
    if (!noAction) {
        return (
            <Grid
                size={{ xs: 12 }}
                display="flex"
                justifyContent={{ xs: "stretch", sm: "flex-end" }}
                alignItems="center"
                flexWrap="wrap"
                gap={1.5}
                mt={2}
                sx={{
                    "& .MuiButton-root": {
                        minHeight: 44,
                        width: { xs: "100%", sm: "auto" },
                    },
                }}
            >
                <FixedActionsContainer fixedActions={fixedActions}>
                    {production && (
                        <Button 
                            disabled={isSubmitting} 
                            startIcon={<FaIndustry />} 
                            variant="contained" 
                            onClick={() => updateProduction()} 
                            color="secondary"
                        >
                            Concluir etapa
                        </Button>
                    )}
                    {!details && !verification && (
                        <Button
                            startIcon={<FaFloppyDisk />}
                            variant="contained"
                            type="submit"
                            color="secondary"
                            disabled={isSubmitting}
                        >
                            {submitButtonText}
                        </Button>
                    )}
                    {verification && (
                        <Button
                            startIcon={<FaCheck />}
                            variant="contained"
                            type="submit"
                            color="secondary"
                            disabled={isSubmitting}
                        >
                            Verificar
                        </Button>
                    )}
                    {onCancel && (
                        <Button variant="outlined" color="primary" onClick={onCancel}>
                            {cancelButtonText}
                        </Button>
                    )}
                </FixedActionsContainer>
            </Grid>
        );
    }
    
    return null;
};

export default FormPageNavigation;
export { FixedActionsContainer };

